<template>
    <div class="table-responsive">
        <table class="table table-hover">
            <thead>
            <tr>
                <th>{{'status' | translate}}</th>
                <th>{{'merchant' | translate}}</th>
                <th>{{'items' | translate}}</th>
                <th>{{'order_information' | translate}}</th>
                <th>{{'amount' | translate}} </th>
                <th>{{'client' | translate}} </th>
                <th @click="sort()"><i :class="sortClass ? 'fa fa-sort-amount-asc' : 'fa fa-sort-amount-desc'"></i> {{'date' | translate}}</th>
                <th>{{'edit' | translate}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="order, index in orders">
                <td>
                    <template v-for="stat in order.status">
                        <span :class="stat.style"><i :class="stat.icon"></i></span><br/>
                    </template>
                </td>
                <td>
                    <ol style="padding-left:20px">
                        <template v-for="merchant in order.merchants">
                            <template v-if="typeof merchant.status !== 'undefined'">
                                <span v-if="merchant.price_reduction_count > 0" class="text-additional">
                                    <li>
                                        <i class="fa fa-euro mr-5"></i> {{merchant.name}}
                                    </li>
                                </span>
                                <span v-else :class="merchant.status.style">
                                    <li>
                                        <i :class="merchant.status.icon"></i> {{merchant.name}}
                                    </li>
                                </span>
                            </template>
                            <template v-else>
                                {{merchant.name}}
                            </template>
                        </template>
                    </ol>
                </td>
                <td>
                    <ul class="list-unstyled">
                        <template v-for="item in order.lines">
                            <span v-if="typeof item.status !== 'undefined'" :class="item.status.style">
                                <li>{{item.sku}}</li>
                            </span>
                        </template>
                    </ul>
                </td>
                <td>
                    <template v-if="order.payment_method === 'warentrade'" >
                        <img class="img-responsive img-channel" src="static/img/warentrading.svg">
                    </template>
                    <template v-else>
                        <img class="img-responsive img-channel" :src="`static/img/${order.sales_channel}.svg`">
                    </template>
                    {{'order' | translate}} #: {{order.ext_order_id}}<br>
                    {{'qualibet_id' | translate}}: {{order.id}}<br/>
                    <small class="text-muted">{{'payment_method' | translate}}: {{order.payment_method}}</small><br/>
                    <template  v-if="$store.getters.user.roles.admin === true">
                        <button class="btn btn-flat btn-danger mb-10 mt-10" @click="reIndexOrder(order.id)">
                            <i class="fa fa-refresh mr-5"></i> {{'reindex_order' | translate}}
                        </button>
                    </template>
                </td>
                <td>{{order.order_total | currency}}<br><small class="text-muted">{{order.number_of_lines}} {{'items' | translate}}</small></td>
                <td>{{order.customer.customer_id}}<br><small class="text-muted">{{order.customer.delivery_first_name}} {{order.customer.delivery_last_name}}</small></td>
                <td>{{order.order_date | orderDate}}<br><small class="text-muted">{{order.order_date | orderDate(true)}}</small></td>
                <td>
                    <router-link :to="'/orders/'+order.id"><b-btn class="btn btn-info btn-app"><i class="fa fa-edit"></i>{{'edit' | translate}}</b-btn></router-link>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
  props: ['orders'],
  data () {
    return {
      sortClass: window.localStorage.getItem('sortType') ? window.localStorage.getItem('sortType') === 'asc' : false
    }
  },
  methods: {
    reIndexOrder (orderId) {
        if (this.$store.getters.user.roles.admin === true) {
            API.put(`orders/${orderId}/reindex`, {})
              .then(response => {
                  this.$store.commit('pushAlert', {
                      dismiss: 4,
                      type: 'success',
                      message: 'Update Successful',
                      icon: 'icon fa fa-check',
                      show: true
                  })
              })
              .catch(error => {
                  this.alerts.push({
                      dismiss: 4,
                      type: 'danger',
                      message: 'Something went wrong',
                      icon: 'fa fa-ban',
                      show: true
                  })
              })
        }
    },
    sort () {
      this.sortClass = !this.sortClass
      this.$emit('sort', this.sortClass ? 'asc' : 'desc');
    }
  },
  watch: {
    orders () {}
  }
}
</script>
<style>
    .sortable:hover {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/tools/Tables/OrdersTable.vue